import { render, staticRenderFns } from "./FontAwsome.vue?vue&type=template&id=62eda2b4&"
import script from "./FontAwsome.vue?vue&type=script&lang=js&"
export * from "./FontAwsome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports